<script setup>
import bodymovin from 'lottie-web/build/player/lottie_light';
import { onBeforeUnmount, onMounted, shallowRef, useTemplateRef } from 'vue';
import blackSpinner from '@/assets/animations/black-spinner.json';
import whiteSpinner from '@/assets/animations/white-spinner.json';

const props = defineProps({
    color: {
        type: String,
        default: 'black',
        validator: (v) => ['black', 'white'].includes(v),
    },
    size: {
        type: String,
        default: 'md',
        validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
});

const spinner = useTemplateRef('spinner');
const animation = shallowRef();

onMounted(() => {
    animation.value = bodymovin.loadAnimation({
        container: spinner.value,
        animationData: props.color === 'black' ? blackSpinner : whiteSpinner,
        renderer: 'svg',
        autoplay: true,
        loop: true,
    });
});

onBeforeUnmount(() => {
    if (animation.value) {
        animation.value.destroy();
    }
});
</script>

<template>
    <div
        ref="spinner"
        class="relative"
        role="status"
        :aria-label="$t('general.loading')"
        :class="{
            'size-8': size === 'sm',
            'size-16': size === 'md',
            'size-20': size === 'lg',
        }"
    />
</template>
